import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import { SWAL_SETTINGS, INPUT_LENGTH_15, INPUT_LENGTH_50 } from "../../../../utils/Constants";
import {
    handleServerValidations,
    DT,
    globalLoader
} from "../../../../utils/commonfunction";
import * as Yup from "yup";
import CustomError from "../../../../utils/customError";
import { useTranslation } from "react-i18next";
import { Details, Edit } from "../../services/medicalCondition.services";
import CustomCkeditor from "../../common/customeditor";


const EditMedicalCondition = (props) => {
    const navigate = useNavigate();
    const params = useParams();
    const { t } = useTranslation();
    const [showdefault, setShowDefault] = useState({});
    const [previewimage, setPreviewImage] = useState("");
    const [saveType, setSaveType] = useState("");
    const [dataLoaded, setDataLoaded] = useState(false);
    const breadcrumbs = [
        { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
        {
            title: t("Medical Conditions"),
            url: "/admin/medical-conditions/list/1",
        },
        { title: t("admin.cafes.link_edit"), url: "" },
    ];

    useEffect(() => {
        Details(params.id)
            .then((response) => {
                setShowDefault(response && response.data ? response.data : []);
                setTimeout(() => {
                    setDataLoaded(true);
                }, 100);
            })
            .catch((error) => {
                console.log("error=====>", error);
            });
    }, [params.id]);


    const validationSchema = Yup.object().shape({
        name: Yup.string().trim().max(50, "Medical Condition name must not be more than 50 characters.").required("Medical Condition name is required"),
        // expiry_date: Yup.date().required("Expiry date is required"),
        // quantity: Yup.string()
        //     .transform((value, originalValue) => originalValue ? String(originalValue) : value)
        //     .trim()
        //     .required("Quantity is required")
        //     .test('no-decimal', 'Quantity cannot be a decimal', value => {
        //         return value ? !value.includes('.') : true;
        //     })
        //     .test('no-negative', 'Quantity cannot be negative', value => {
        //         return value ? !value.startsWith('-') : true;
        //     })
        //     .test('max-digits', 'Quantity cannot be more than 10 digits', value => {
        //         return value ? value.length <= 10 : true;
        //     })
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: showdefault && showdefault.name ? showdefault.name : "",
        },
        validationSchema: validationSchema,
        onSubmit: (values, { setSubmitting, resetForm }) => {
            globalLoader(true);
            let formData = new FormData();
            formData.append("o_id", params.id);
            formData.append("name", values.name);
            Edit(formData)
                .then((response) => {
                    setSubmitting(false);
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        globalLoader(false);
                        if (saveType !== "Save") {
                            navigate(`/admin/medical-conditions/list/1`);
                        }
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                    }
                    globalLoader(false);
                })
                .catch((error) => {
                    Swal.fire({
                        icon: "error",
                        text: handleServerValidations(error),
                        ...SWAL_SETTINGS,
                    });
                    console.log("error ====> ", error);
                });
        },
    });
    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <form onSubmit={formik.handleSubmit}>
                <div className="row row-sm">
                    <div className="col-lg-12 col-md-12 animation_fade">
                        <div className="card custom-card">
                            <div className="card-body">
                                <div>
                                    <h6 className="main-content-label mb-3">
                                        {t("Edit Medical Condition")}
                                    </h6>
                                </div>
                                <div className="row row-sm">

                                    <div className="col-md-6 text-center form-group">
                                        <label htmlFor="name" className="text-left d-flex">
                                            {t("Medical Condition Name")}:
                                            <span className="requirestar">*</span>{" "}
                                        </label>
                                        <input
                                            name="name"
                                            id="name"
                                            type="text"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.name}
                                            className="form-control"
                                            placeholder={t("Enter Medical Condition name")}
                                        />
                                        <span className="text-danger d-flex text-left">
                                            <CustomError shortCodes={[INPUT_LENGTH_50]} name="name" form={formik} />
                                        </span>
                                    </div>
                                    
                                    {/* <div className="col-lg-12 text-center form-group">
                                        <label htmlFor="subject" className="text-left d-flex">
                                            {t("Description")}:<span className="requirestar">*</span>
                                        </label>
                                        {dataLoaded ? (
                                            <CustomCkeditor
                                                fieldname={"description"}
                                                setFieldValue={formik.setFieldValue}
                                                value={formik.values.description}
                                                setFieldTouched={formik.setFieldTouched}
                                            />
                                        ) : ""}
                                        <span className="text-danger d-flex text-left">
                                            <CustomError name="description" form={formik} />
                                        </span>
                                    </div> */}
                                    <div className="mt-5">
                                        <button
                                            onClick={() => {
                                                setSaveType("Save");
                                            }}
                                            className="btn btn-info mr-2"
                                            type="submit"
                                        >
                                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                            {t("admin.button.btn_save")}
                                        </button>
                                        <button
                                            onClick={() => {
                                                setSaveType("");
                                            }}
                                            className="btn btn-success mr-2"
                                            type="submit"
                                        >
                                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                            {t("admin.button.btn_save_exit")}
                                        </button>
                                        <button
                                            className="btn ripple btn-secondary"
                                            type="button"
                                            onClick={() => navigate(-1)}
                                        >
                                            <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                                            {t("admin.button.btn_cancel")}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
};

export default EditMedicalCondition;